// Turno según la hora de la salida. Umbrales: mañana <12, tarde 12–18, noche ≥19.
export const turnoDeHora = (hour) => {
  if (!hour) return null;
  const h = parseInt(String(hour).split(":")[0], 10);
  if (isNaN(h)) return null;
  if (h < 12) return "manana";
  if (h < 19) return "tarde";
  return "noche";
};

export const TURNO_OPTIONS = [
  { label: "Mañana", value: "manana" },
  { label: "Tarde", value: "tarde" },
  { label: "Noche", value: "noche" },
];

export const TURNO_LABELS = {
  manana: "Mañana",
  tarde: "Tarde",
  noche: "Noche",
};
